export default __webpack_public_path__ + "static/media/simple-and-convenient.88ffe1a3.svg";